import { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import configData from "../config.json";
import "../styles/category.css";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await fetch(`${configData.SERVER_URL}/category`);
        const data = await res.json();
        setCategories(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    getCategory();
  }, []);

  return (
    <div className="container py-4">
      {/* Header */}
      <div className="text-center mb-4">
        <h2 className="fw-bold text-success">Product Categories</h2>
        <p className="text-muted">Browse products by category</p>
      </div>

      {/* Error */}
      {error && <p className="text-danger text-center">{error}</p>}

      {/* Content */}
      <div className="row g-4 justify-content-center">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="col-6 col-sm-4 col-md-3 col-lg-2 text-center"
              >
                <Skeleton circle height={120} width={120} />
                <Skeleton width={80} className="mt-2" />
              </div>
            ))
          : categories.map((cat) => (
              <div
                key={cat.CategoryID}
                className="col-6 col-sm-4 col-md-3 col-lg-2"
              >
                <Link
                  // to={`/product/${cat.CategoryID}`}
                  to={"/productCategory"}
                  state={{ 
                    categoryId: cat.CategoryID 
                  }}
                  className="text-decoration-none"
                >
                  <div className="card border-0 shadow-sm text-center h-100 category-card">
                    <div className="p-3">
                      <img
                        src={`${configData.IMAGE_URL}/categories/${cat.Image}`}
                        alt={cat.CategoryName || "Category"}
                        className="img-fluid rounded-circle"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                        }}
                      />
                    </div>

                    <div className="card-body pt-0">
                      <h6 className="text-dark fw-semibold">
                        {cat.CategoryName || "Category"}
                      </h6>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Category;